import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";
import MyDrawer from "../../../../components/Admin/Drawer";
import Carousels from "./Carousels";
import { CarouselProvider } from "../../../../components/Carousel/CarouselContext";
import { useStyles, theme } from "../../theme.js";

const CarouselAdminPage = (props) => {
  const classes = useStyles();

  return (
    <CarouselProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <Carousels></Carousels>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </CarouselProvider>
  );
};

export default CarouselAdminPage;
